export const allowedEmailMimeTypes = [
  "message/rfc822",
  "application/vnd.ms-outlook",
];
